
















import {computed, defineComponent} from "@vue/composition-api"
import {useGetters} from "vuex-composition-helpers"
import Admissions from "@/apps/StudentExchangeOverviewWidget/components/Admissions.vue"
import {IStudy} from "@/apps/StudentExchangeOverviewWidget/models/studies-viewmodel";

export default defineComponent({
    name: "Studies",
    components: {
        Admissions
    },
    setup: () => {
        const {getLabels, getStudies, getSelectedFilterYear} = useGetters([
            'getLabels',
            'getStudies',
            'getSelectedFilterYear'
        ])

        const studyCollection = computed(() => {
            return getStudies.value.filter((study: IStudy) => {
                if (getSelectedFilterYear.value) {
                    return study.academicYearId === getSelectedFilterYear.value
                } else {
                    return true
                }
            })
        })

        return {
            getLabels,
            studyCollection,
        }
    }
})
